import {HttpRes} from '../../http/http_res'
const DEFAULT_ERROR = "Ha ocurrido un error. Intenta por favor más tarde.";
export default {
   methods: {
      /**
       * Solicita servicio con metodo POST
       * @param {String} uri 
       * @param {*} payload 
       * @returns {HttpRes} Resultado de la peticion
       */
      async xpost(uri, payload) {
         try {
            const res = await axios.post(uri, payload);
            return new HttpRes(true, res.data);
         }
         catch (error){
            return new HttpRes(false, null, this.catchError(error));
         }
      },

      async xget(uri){
         try {
            const res = await axios.get(uri);
            return new HttpRes(true, res.data);
         }
         catch (error){
            return new HttpRes(false, null, this.catchError(error));
         }
      },

      catchError(e){
         if(e && e.response && e.response.data && e.response.data.error){
            return e.response.data.error
         }
         else {
            return DEFAULT_ERROR;
         }
      }
   }
}